import { LoadingButton } from "./loading-button";
export var LOADING_BUTTON_DIRECTIVES = [
    LoadingButton
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button-loading/index.js
// module id = 143
// module chunks = 4